import { t } from "@lingui/macro";
import { useAtomValue, useSetAtom } from "jotai";

import { getRoundFromIdAtom } from "@/screens/BookingDetail/NewPatronBookingFlow/components/EditBooking/atoms/selectors/getRoundFromIdAtom/getRoundFromIdAtom";
import { PeopleIndicatorIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import {
  HStack,
  Pressable,
  Text,
} from "@whoosh/design-system/src/components/primitive";

import { setNonPlayingHostAtom } from "../../../../../../../../../atoms/actions/SetNonPlayingHostAtom/setNonPlayingHostAtom";

export const SetNonPlayingHostMenuItem = ({
  roundId,
  closeMenu,
}: {
  roundId: string;
  closeMenu: () => void;
}) => {
  const setNonPlayingHost = useSetAtom(setNonPlayingHostAtom);
  const round = useAtomValue(getRoundFromIdAtom(roundId));

  const isNonPlaying = !!round?.isNonPlayingHost;

  return (
    <Pressable
      onPress={() => {
        setNonPlayingHost({ roundId });
        closeMenu();
      }}
    >
      <HStack gap={3} paddingHorizontal={4} paddingVertical={3}>
        <PeopleIndicatorIcon color="text-primary" />
        <Text>{isNonPlaying ? t`Set to Playing` : t`Non-Playing Host`}</Text>
      </HStack>
    </Pressable>
  );
};
